var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinbookLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 64,
    viewBox: "0 0 141 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.416%",
    y1: "41.41%",
    x2: "134.123%",
    y2: "76.129%",
    id: "xqb1q5znkc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#033898",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "87.583%",
    y1: "22.619%",
    x2: "26.933%",
    y2: "76.499%",
    id: "fpyn7jdjvd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5AE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "81.414%",
    x2: "87.442%",
    y2: "34.189%",
    id: "239mj5i86e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D5AE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-43.7%",
    y: "-36.5%",
    width: "187.5%",
    height: "187.5%",
    filterUnits: "objectBoundingBox",
    id: "y4faf4h01a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.074847028 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "qlx3vixicb",
    x: 0,
    y: 0,
    width: 41.151,
    height: 41.151,
    rx: 6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.434 25.458c.339 0 .53-.2.53-.557v-2.316c0-.356-.191-.556-.53-.556H66.71c-.339 0-.53.2-.53.556V37.06c0 .356.191.556.53.556h2.328c.339 0 .53-.2.53-.556v-4.944h4.761c.339 0 .53-.2.53-.557v-2.315c0-.357-.191-.557-.53-.557h-4.762v-3.229h4.868zM77.225 25.146h2.117c.338 0 .529-.2.529-.556v-2.005c0-.356-.19-.556-.53-.556h-2.116c-.338 0-.529.2-.529.556v2.005c0 .356.19.556.53.556zm0 12.47h2.117c.338 0 .529-.2.529-.556V27.04c0-.357-.19-.558-.53-.558h-2.116c-.338 0-.529.2-.529.557v10.02c0 .357.19.557.53.557zM88.059 26.17c-1.353 0-2.254.556-2.752 1.33v-.46c0-.357-.19-.558-.529-.558h-2.116c-.339 0-.53.2-.53.557v10.02c0 .357.191.557.53.557h2.116c.339 0 .53-.2.53-.556v-5.946c0-1.314.592-1.87 1.544-1.87.805 0 1.419.49 1.419 1.603v6.213c0 .356.19.556.529.556h2.116c.339 0 .53-.2.53-.556v-6.503c0-2.783-1.419-4.386-3.387-4.386zM99.76 26.17c-1.416 0-2.445.503-3.153 1.352v-4.937c0-.356-.19-.556-.53-.556h-2.116c-.338 0-.529.2-.529.556V37.06c0 .356.19.556.53.556h2.116c.338 0 .529-.2.529-.556v-.484c.708.85 1.737 1.352 3.153 1.352 2.773 0 5.059-2.56 5.059-5.879 0-3.318-2.286-5.878-5.059-5.878zm-.635 8.596c-1.46 0-2.518-1.047-2.518-2.717 0-1.67 1.058-2.716 2.518-2.716 1.46 0 2.519 1.046 2.519 2.716 0 1.67-1.058 2.717-2.519 2.717zM111.631 37.928c3.111 0 5.609-2.56 5.609-5.879 0-3.318-2.498-5.878-5.609-5.878-3.111 0-5.609 2.56-5.609 5.878s2.498 5.88 5.609 5.88zm0-3.251c-1.376 0-2.434-1.047-2.434-2.628 0-1.58 1.058-2.627 2.434-2.627 1.376 0 2.434 1.046 2.434 2.627 0 1.581-1.058 2.628-2.434 2.628zM124.052 37.928c3.111 0 5.609-2.56 5.609-5.879 0-3.318-2.498-5.878-5.609-5.878-3.111 0-5.609 2.56-5.609 5.878s2.498 5.88 5.61 5.88zm0-3.251c-1.376 0-2.434-1.047-2.434-2.628 0-1.58 1.058-2.627 2.434-2.627 1.376 0 2.434 1.046 2.434 2.627 0 1.581-1.058 2.628-2.434 2.628zM140.875 36.948l-3.28-4.899 3.111-4.899c.233-.378.085-.668-.339-.668h-2.434a.692.692 0 0 0-.634.357l-2.73 4.48v-8.734c0-.356-.191-.556-.53-.556h-2.116c-.339 0-.53.2-.53.556V37.06c0 .356.191.556.53.556h2.116c.339 0 .53-.2.53-.556v-4.327l2.941 4.527c.148.245.36.356.635.356h2.413c.423 0 .571-.29.317-.668z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 8)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#y4faf4h01a)",
    xlinkHref: "#qlx3vixicb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#qlx3vixicb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.73 16.913c2.474.755 8.742-3.92 8.742-3.92s-5.091-1.78-10.182-1.99c-5.09-.21-4.236 5.91-4.236 5.91s3.203-.754 5.677 0z",
    fill: "url(#xqb1q5znkc)",
    transform: "translate(23.158 15.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.472 19.422S1.026 21.564.17 28.992c0 0-2.803-14.263 14.3-15.995v6.425z",
    fill: "url(#fpyn7jdjvd)",
    transform: "translate(23.158 15.482)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.64 0v6.807S3.306 7.31.19 16.996c0 0-3.493-15.9 19.45-16.996",
    fill: "url(#239mj5i86e)",
    transform: "translate(23.158 15.482)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinbookLogoLight);
export default __webpack_public_path__ + "static/media/finbookLogo_light.9f9f87eeeb2c6bf786f71e3c9855408c.svg";
export { ForwardRef as ReactComponent };